<script>
    import NavBar from "../components/NavBar.svelte";
    import { db } from "../firebase";
    import { doc, getDoc, setDoc } from "firebase/firestore";

    async function updateSettings() {

        var accountName = document.getElementById("account-name").value;
        var doubleOptInMessage = document.getElementById("double-opt-in-message").value;
        var messageHeader = document.getElementById("message-header").value;
        var messageFooter = document.getElementById("message-footer").value;

        const data = {
            accountName: accountName,
            doubleOptInMessage: doubleOptInMessage,
            messageHeader: messageHeader,
            messageFooter: messageFooter
        };

        await setDoc(doc(db, "settings", "fOOlT8Md7uWr4C1vpF7yR7eJKMX2"), data);

        alert("Saved Changes!");

    }

    async function getSettingsData() {
        const docRef = doc(db, "settings", "fOOlT8Md7uWr4C1vpF7yR7eJKMX2");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            return docSnap.data();
        } else {
            return "";
        }
    }

    let promise = getSettingsData();
</script>

<div>
    <NavBar/>
    <div class="app-container">
        <div class="box">
            {#await promise}
                <p>Loading...</p>
            {:then data}
                <div class="field">
                    <label class="label">Account Name</label>
                    <div class="control">
                        <input id="account-name" class="input" type="text" placeholder="" value="{data.accountName}">
                    </div>
                </div>
                <hr>
                <h3 class="is-size-4 mb-3">Opt-In</h3>
                <div class="field">
                    <label class="label">Double Opt-In Message</label>
                    <div class="control">
                        <textarea id="double-opt-in-message" class="textarea" placeholder="e.g. Please click the link to confirm you would like to resieve messages!" value="{data.doubleOptInMessage}"></textarea>
                        <p>https://sms.jfv.one/#/opt-in/example</p>
                    </div>
                </div>
                <hr>
                <h3 class="is-size-4 mb-3">Message</h3>
                <div class="field">
                    <label class="label">Header</label>
                    <div class="control">
                        <input id="message-header" class="input" type="text" placeholder="" value="{data.messageHeader}">
                    </div>
                </div>
                <div class="field">
                    <label class="label">Footer</label>
                    <div class="control">
                        <input id="message-footer" class="input" type="text" placeholder="" value="{data.messageFooter}">
                    </div>
                </div>
                <hr>
                <div class="control">
                    <button class="button is-dark" type="button" on:click={updateSettings}>Save Changes</button>
                </div>
            {:catch error}
                <p>Sorry, there was an error loading in your settings!</p>
            {/await}
        </div>
    </div>
    <br>
</div>